import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ThisReceiver } from "@angular/compiler";
import { Injectable } from "@angular/core";
import { catchError } from "rxjs/operators";

import {
  Answer,
  FormResponse,
  HttpService,
  ConfigMapService,
  CodehelpService,
  LoginInfo,
  CONFIG,
} from "virtue-form";
import { GlobalVarService } from "./global-var.service";
import { element } from "protractor";
import { CommonHandlerService } from "./common-handler.service";
export class Student {
  public name: string;
  public email: string;
  public coupon: string;
}
@Injectable({
  providedIn: "root",
})
export class ApiService {
  answerdata: Array<Answer> = [];
  formSubmitId: string = "";
  formResponse!: FormResponse;
  formData: any;
  componentElement: any;
  basepath: string;
  feedbackformSubmitId = "";
  fileData: any = {};
  fileAnalysisData: any = {};
  submitChoiceResponse!: any;
  submitChoiceSubmitedId = "";
  formReqData!: any;
  FormFilledData = {};
  formVersion: any;
  data = {};
  letter: any;

  org: any;
  baseUrl = "https://tech.virtueanalytics.com/v-api/";

  constructor(
    private httpser: HttpService,
    private configMap: ConfigMapService,
    private codehelp: CodehelpService,
    private globalvar: GlobalVarService,
    private http: HttpClient,
    private common: CommonHandlerService
  ) {
    this.org = JSON.parse(this.codehelp.getLoggedUserDetail());
  }

  resetFormDetail() {
    this.formSubmitId = "";
    this.formResponse = {} as FormResponse;
  }
  getHost() {
    return this.httpser.getHost();
  }

  getstatelistall() {
    return this.httpser.get<any>(
      "collegeProfile/allColleges/states?showInactive=false",
      ""
    );
  }
  // getCalculatorExisits ravi

  // getstateForCalculatorExists() {
  //   return this.httpser.get<any>(
  //     "collegeStateAid/availableStateCalculators/stateCodes",
  //     ""
  //   );
  // }

  getstateForCalculatorExists() {
    return this.httpser.get<any>(
      "collegeStateAid/availableStateCalculators/stateCodes",
      ""
    );
  }
  updateClientTraffic() {
    const url = "client-traffic";
    const sessionId = localStorage.getItem("sessionId")
      ? localStorage.getItem("sessionId")
      : "";
    const body = {
      org: {
        id: this.codehelp.getProviderID(),
        name: "Top5",
      },
      sessionedUserId: sessionId,
      appUseAnalysis: {
        useStartAt: new Date().toISOString(),
        useEndAt: new Date().toISOString(),
      },
      serviceType: this.globalvar.serviceConfig.serviceType,
      serviceUrl: this.globalvar.serviceConfig.serviceUrl,
    };
    this.httpser
      .post(url, body, this.globalvar.isTokenLogin)
      .then((resp) => {});
  }

  getPocketCostForCollegeList(
    efc,
    act,
    sat,
    gpa,
    state,
    filterstate,
    filterControl,
    pocketCost,
    HBCUCollege,
    onlyNonHBCUColleges,
    enrollmentType,
    Domicline,
    acceptanceRate,
    reciprocityStateCodes,
    rankMin,
    rankMax,
    Collegedistancemax,
    isProgramRank,
    isDistance,
    cityName
  ) {
    const reciprocityStateList = [
      ...new Set(reciprocityStateCodes.map((item) => item.toLowerCase())),
    ];

    let stategrant = this.globalvar.answerMap.get(99999);
    console.log(stategrant, "StateGrant");

    // Use nullish coalescing operator to set an empty string if StategrantValue is undefined
    let StategrantValue = stategrant?.value ?? "";

    // let url = 'https://tech.virtueanalytics.com/v-failsafe-mvt/combinedAid/outOfPocket/all';
    const url = "combinedAid/outOfPocket/all";
    const body = {
      efc: efc,
      stateAid: StategrantValue,
      act: act,
      sat: sat,
      gpa: gpa,
      domicileAndResidency: Domicline,
      studentEnrollmentStatus: "FULL_TIME",
      studentStateCode: state,
      reciprocityStateCodes: reciprocityStateList,
      filters: {
        usNewsRank: {
          overallCollegeRankInUs: {
            min: isProgramRank ? (rankMin ? rankMin : "") : "",
            max: isProgramRank ? (rankMax ? rankMax : "") : "",
          },
        },
        collegeDistance: {
          stateCode: state,
          cityName: cityName,
          collegesWithinDistance: {
            min: 0,
            max: this.globalvar.isInternatinalStudent
              ? ""
              : isDistance
              ? Collegedistancemax
                ? Collegedistancemax
                : ""
              : "",
          },
        },
        stateCodes: filterstate,
        acceptanceRateLevels: acceptanceRate,
        maxCost: pocketCost,
        control: filterControl,
        showNegativeCoa: true,
        onlyHBCUColleges: HBCUCollege,
        onlyNonHBCUColleges: onlyNonHBCUColleges,
        enrollmentType: enrollmentType,
        internationalStudent: this.globalvar.isInternatinalStudent,
      },
    };
    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }
  getAllPocketCostForCollegeList(
    efc,
    act,
    sat,
    gpa,
    state,
    filterstate,
    filterControl,
    pocketCost,
    HBCUCollege,
    onlyNonHBCUColleges,
    enrollmentType,
    Domicline,
    acceptanceRate,
    reciprocityStateCodes,
    rankMin,
    rankMax,
    Collegedistancemax,
    isProgramRank,
    isDistance,
    cityName
  ) {
    debugger;
    const reciprocityStateList = [
      ...new Set(reciprocityStateCodes.map((item) => item.toLowerCase())),
    ];
    // let url = 'https://tech.virtueanalytics.com/v-failsafe-mvt/combinedAid/outOfPocket/all';
    const url = "combinedAid/outOfPocket/all";
    const body = {
      efc: efc,
      act: act,
      sat: sat,
      gpa: gpa,
      domicileAndResidency: Domicline,
      studentEnrollmentStatus: "FULL_TIME",
      studentStateCode: state,
      reciprocityStateCodes: reciprocityStateList,
      filters: {
        usNewsRank: {
          overallCollegeRankInUs: {
            min: isProgramRank ? (rankMin ? rankMin : "") : "",
            max: isProgramRank ? (rankMax ? rankMax : "") : "",
          },
        },
        collegeDistance: {
          stateCode: state,
          cityName: cityName,
          collegesWithinDistance: {
            min: 0,
            max: this.globalvar.isInternatinalStudent
              ? ""
              : isDistance
              ? Collegedistancemax
                ? Collegedistancemax
                : ""
              : "",
          },
        },
        stateCodes: [],
        acceptanceRateLevels: acceptanceRate,
        maxCost: pocketCost,
        control: filterControl,
        showNegativeCoa: true,
        onlyHBCUColleges: HBCUCollege,
        onlyNonHBCUColleges: onlyNonHBCUColleges,
        enrollmentType: enrollmentType,
        internationalStudent: this.globalvar.isInternatinalStudent,
      },
    };
    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }

  getFeedBackFormData(formId: string) {
    return this.httpser.get<FormData>(
      "form",
      formId,
      this.globalvar.isTokenLogin
    );
  }

  getFormFilled(id: string) {
    return this.httpser.get<FormResponse>(
      "formFilled",
      id,
      this.globalvar.isTokenLogin
    );
  }

  getFormFilledCallBack(id: string, callback: Function) {
    this.httpser
      .get<FormResponse>("formFilled", id, this.globalvar.isTokenLogin)
      .then((resp) => callback(resp));
  }

  getTop5SubmissionsbyFormFilledId(id: string, callback: Function) {
    this.httpser
      .get<FormResponse>("top5UserSubmission", id, this.globalvar.isTokenLogin)
      .then(
        (resp) => {
          callback(resp);
        },
        (error) => {
          if (error.status == 500) {
            callback([]);
            console.error(
              "top5UserSubmission Entity Not Available",
              error.status
            );
          } else {
            callback([]);
            console.error("top5UserSubmission Somthing Worng", error.status);
          }
        }
      );
  }

  //Added services form mse Service

  login(input: string) {
    return this.httpser.post<LoginInfo>(
      "virtueAuth/login",
      input,
      this.globalvar.isTokenLogin
    );
  }

  loggedInInfo() {
    return this.httpser.get<any>(
      "virtueAuth/loggedUser",
      "",
      this.globalvar.isTokenLogin
    );
  }

  loginStdentAsCounselor(studentId: string) {
    return this.httpser.get<any>(
      "top5Subscription/counselor/getStudentToken/" + studentId,
      "",
      this.globalvar.isTokenLogin
    );
  }

  // getOrganization(serviceUrl: string) {
  //   let url = 'organisation/search';
  //   let body = {
  //     serviceConfig: {
  //       serviceUrl: serviceUrl,
  //       serviceType: 'CSR',
  //     },
  //   };
  //   return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  // }

  getProviderUniversityState() {
    const url = "fieldConfig/search";
    const body = {
      configId: "provider_university_state", // self- state keuka's new york
      providerId: this.codehelp.getProviderID(),
    };

    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }

  getProviderUniversity() {
    const url = "fieldConfig/search";
    const body = {
      configId: "provider_university", // self - college
      providerId: this.codehelp.getProviderID(),
    };
    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }

  getUesrProfileData(loginId: string) {
    return this.httpser.get<any>(
      "userProfile",
      loginId,
      this.globalvar.isTokenLogin
    );
  }

  getFormData(cb: Function) {
    this.httpser
      .get<FormData>("form", this.globalvar.formId, this.globalvar.isTokenLogin)
      .then(
        (data) => {
          this.formData = data;
          this.componentElement = data["filledByInfos"];
          cb(data);
        },
        (error) => {
          console.error("error while fetching form Details");
        }
      );
  }

  submitFeedbackForm(
    ans: Map<Number, Answer>,
    pageid: number,
    last: boolean,
    formType: string,
    callback: Function
  ) {
    this.answerdata = [];
    let org = JSON.parse(this.codehelp.getLoggedUserDetail());
    ans.forEach((value, _name) => this.answerdata.push(value));
    let path = "formFilled";
    let answers = this.answerdata;
    if (pageid === 0 && this.feedbackformSubmitId == "") {
      let body = {
        formTypeEnum: "FEEDBACK",
        formRef: {
          id: this.globalvar?.feedBackFormData.id,
          name: this.globalvar?.feedBackFormData?.formName,
        },
        // organisationRef: {
        //   id: this.codehelp.getProviderID(),
        //   name: CONFIG.organizationName,
        // },
        organisationRef: org.orgRef,
        feedbackBackRef: {
          formFilledId: this.globalvar.formFilledSubmitID,
          serviceType: formType,
        },
        answers: answers,
        submissionState: "INCOMPLETE",
      };

      this.httpser.post<FormResponse>(path, body).then((resp: FormResponse) => {
        callback(resp);
      });
    }
  }

  getRegistredSubmissionList(id: string) {
    const body = {
      filledByIds: [id],
      formType: "TOP5", //added for issue to get submmision data.
    };
    return this.httpser.post("formFilled/search", body);
  }

  // Start : Call Back Function for Form Filled Info
  getRegistredSubmissionCallBackList(id: string, callback: Function) {
    const body = {
      filledByIds: [id],
      formType: "TOP5", //added for issue to get submmision data.
    };
    // return this.httpser.post('formFilled/search',body);
    this.httpser
      .post<any>("formFilled/search", body, this.globalvar.isTokenLogin)
      .then((resp: any) => {
        callback(resp);
      });
  }
  //End : Call Back Function for Form Filled Info

  sendMail(mailUrl: string, mailto: string) {
    let url = "top5UserSubmission/mailMe";
    // let url =
    //   'https://tech.virtueanalytics.com/v-top5-dashboard/top5UserSubmission/mailMe';

    const userProfile = JSON.parse(this.codehelp.getUserProfile());
    const body = {
      submissionUrl: mailUrl,
      userProfile: userProfile,
      additionalEmails: [mailto],
    };
    // const body =
    //   {
    //     'submissionUrl': mailUrl,
    //     'userProfile': {
    //       'id': 'string',
    //       'metaData': {
    //         'createdAt': 'string',
    //         'updatedAt': 'string',
    //         'version': 0,
    //         'state': 'ACTIVE'
    //       },
    //       'orgRef': {
    //         'id': 'string',
    //         'name': 'string'
    //       },
    //       'fullName': 'string',
    //       'email': 'string',
    //       'username': 'string',
    //       'type': 'STUDENT',
    //       'avatar': 'string',
    //       'createdBy': {
    //         'userReference': {
    //           'id': 'string',
    //           'name': 'string'
    //         },
    //         'autoIssueTokens': true
    //       },
    //       'deleted': true
    //     },
    //     'additionalEmails': [
    //       'string'
    //     ]
    //   }

    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }

  getOrganizationByOrgAccessKey(AccessKey: string) {
    const url = "organisation/search";
    const body = {
      accessKey: AccessKey,
    };
    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }
  userType: any;
  getProductKeyontool(callback: Function) {
    let profile = JSON.parse(this.codehelp.getUserProfile() || "{}");
    this.userType = profile?.type || "";
    if (this.userType == "COUNSELOR") {
      const url = "product/productId";
      const payload = "PRODUCT_FOR_COUNSELOR_ADDITION";
      this.httpser
        .post(url, JSON.stringify(payload), this.globalvar.isTokenLogin)
        .then((resp: any) => {
          callback(resp);
        });
    } else if (this.userType == "STUDENT") {
      const url = "product/productId";
      const payload = "PRODUCT_FOR_STUDENT_ADDITION";
      this.httpser
        .post(url, JSON.stringify(payload), this.globalvar.isTokenLogin)
        .then((resp: any) => {
          callback(resp);
        });
    }
  }
  getProductKey(callback: Function) {
    const url = "product/productId";
    const payload = "PRODUCT_FOR_COUNSELOR_ADDITION";
    this.httpser
      .post(url, JSON.stringify(payload), this.globalvar.isTokenLogin)
      .then((resp: any) => {
        callback(resp);
      });
  }

  // getProductKeyCallBack(callback: Function) {
  //   const url = "product/productId";
  //   const payload = "PRODUCT_FOR_COUNSELOR_ADDITION";
  //   return this.httpser.post(
  //     url,
  //     JSON.stringify(payload),
  //     this.globalvar.isTokenLogin
  //   );
  // }
  getProductKeyForStudent(callback: Function) {
    const url = "product/productId";
    const payload = "PRODUCT_FOR_STUDENT_ADDITION";
    this.httpser
      .post(url, JSON.stringify(payload), this.globalvar.isTokenLogin)
      .then((resp: any) => {
        callback(resp);
      });
    // return this.httpser.post(
    //   url,
    //   JSON.stringify(payload),
    //   this.globalvar.isTokenLogin
    // );
  }
  getOrganizationCSRtop5(serviceUrl: string, serviceType: string) {
    let servicetype = "";
    if (serviceType == "top5") {
      servicetype = "TOP5";
    }
    let checkUrlToPoint = this.common.checkAndSetAPIPoint(
      document.location.hostname
    );
    if (checkUrlToPoint == "Tech" || checkUrlToPoint == "Local") {
      const url = "https://tech.virtueanalytics.com/v-api/organisation/search";
      const body = {
        serviceConfig: {
          serviceUrl: serviceUrl,
          serviceType: servicetype,
        },
      };
      return this.http.post(url, body);
    } else {
      const urlProd = "https://api.virtueanalytics.com/api/organisation/search";
      const body = {
        serviceConfig: {
          serviceUrl: serviceUrl,
          serviceType: servicetype,
        },
      };
      return this.http.post(urlProd, body);
    }
    // if (serviceType != 'top5') {
    //   servicetype = 'CSR';
    // }
  }
  getAllStateList(callback: Function) {
    // const body = {
    //   configId: 'state',
    //   providerId: 'fb062996-cc17-410c-893d-3939eb6e8597',
    // };
    // return this.httpser.post<any>('fieldConfig/search', body);S
    this.configMap.getConfigData(
      "state",
      6,
      (resp) => {
        callback(resp);
      },
      this.globalvar.isTokenLogin
    );
  }

  couponValidation(input: Student) {
    const body = {
      name: input.name,
      email: input.email,
      couponCode: input.coupon,
    };
    return this.httpser.post<any>("virtueAuth/couponValidation", body);
  }

  createCounselor(input: any) {
    let addfullname = input.firstName + " " + input.lastName;
    let body = {
      orgRef: {
        id: this.globalvar.orgRef[0].id,
        name: this.globalvar.orgRef[0].name,
      },
      //fullName: input.fullname,
      email: input.email,
      firstName: input.firstName,
      lastName: input.lastName,
      // username: input.username,
      fullName: addfullname,
      type: "COUNSELOR",
      avatar: "",
    };
    return this.httpser.post<any>(
      "top5Subscription/addCounselor/" + this.globalvar.orgRef[0].id,
      body
    );
  }
  // username: input.email,
  signUpForSubscriptionPayment(
    input: any,
    CouponCode: boolean,
    productkey: string
  ) {
    let url = "payment";
    // let url = "https://tech.virtueanalytics.com/v-stripe-dev/payment";
    let addfullname = input.firstName + " " + input.lastName;
    let body: any = {};
    body = {
      productId: productkey,
      quantity: 1,
      productPurposeEnum: "PRODUCT_FOR_COUNSELOR_ADDITION",
      userProfileEntity: {
        orgRef: {
          id: this.globalvar.orgRef[0].id,
          name: this.globalvar.orgRef[0].name,
        },
        email: input.email,
        firstName: input.firstName,
        lastName: input.lastName,
        fullName: addfullname,
        type: "COUNSELOR",
        avatar: "",
      },
      orgRef: {
        id: this.globalvar.orgRef[0].id,
        name: this.globalvar.orgRef[0].name,
      },
      paymentPlatform: CouponCode ? "COUPON" : "STRIPE",
    };

    if (CouponCode) {
      body.appliedCouponCode = input.appliedCouponCode;
    }
    if (!CouponCode) {
      body.priceId = input.priceId;
    }

    return this.httpser.post<any>(url, body);
  }
  getpriceList(ProductKey) {
    let url = "product/getPrices";
    return this.httpser.post<any>(url, ProductKey);
  }
  // username: input.email
  signUpForSubscriptionPaymentStudent(
    input: any,
    CouponCode: boolean,
    productkey: string
  ) {
    let url = "payment";
    // let url = "https://tech.virtueanalytics.com/v-stripe-dev/payment";
    let addfullname = input.firstName + " " + input.lastName;
    let body: any = {};
    body = {
      productId: productkey,
      quantity: 1,
      productPurposeEnum: "PRODUCT_FOR_STUDENT_ADDITION",
      userProfileEntity: {
        orgRef: {
          id: this.globalvar.orgRef[0].id,
          name: this.globalvar.orgRef[0].name,
        },
        email: input.email,
        firstName: input.firstName,
        lastName: input.lastName,
        fullName: addfullname,
        type: "STUDENT",
        avatar: "",
      },
      orgRef: {
        id: this.globalvar.orgRef[0].id,
        name: this.globalvar.orgRef[0].name,
      },
      paymentPlatform: CouponCode ? "COUPON" : "STRIPE",
    };

    if (CouponCode) {
      body.appliedCouponCode = input.coupon;
    }
    if (!CouponCode) {
      body.priceId = input.priceId;
    }

    return this.httpser.post<any>(url, body);
  }
  PaymentFromTool(productkey: string, priceId: string) {
    let url = "payment";
    const profile = JSON.parse(this.codehelp.getUserProfile() || "{}");
    console.log(profile, "profile");
    this.userType = profile?.type || "";
    // let url = "https://tech.virtueanalytics.com/v-stripe-dev/payment";
    // let addfullname = userInfoObj.firstName + " " + userInfoObj.lastName;
    let body: any = {};
    if (this.userType == "COUNSELOR") {
      body = {
        productId: productkey,
        priceId: priceId,
        quantity: 1,
        productPurposeEnum: "PRODUCT_FOR_COUNSELOR_ADDITION",
        userProfileEntity: JSON.parse(this.codehelp.getUserProfile() || "{}"),
        paymentPlatform: "STRIPE",
        orgRef: {
          id: profile.orgRef.id,
          name: profile.orgRef.name,
        },
      };
    }
    if (this.userType == "STUDENT") {
      body = {
        productId: productkey,
        quantity: 1,
        priceId: priceId,
        productPurposeEnum: "PRODUCT_FOR_STUDENT_ADDITION",
        userProfileEntity: JSON.parse(this.codehelp.getUserProfile() || "{}"),
        orgRef: {
          id: profile.orgRef.id,
          name: profile.orgRef.name,
        },
        paymentPlatform: "STRIPE",
      };
    }
    return this.httpser.post<any>(url, body);
  }

  getCollegeProfileById(collegeId: string) {
    return this.httpser.get<any>(
      "collegeProfile/" + collegeId + "?getExtendedEntity=true",
      "",
      this.globalvar.isTokenLogin
    );
  }

  getAllCollege() {
    const url = "collegeProfile/search";
    const body = {
      onlyRef: true,
    };
    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }

  ocrSubmitList(formFilled, callback) {
    const org = JSON.parse(this.codehelp.getLoggedUserDetail());
    const url = "ocrSubmit";
    let supportDoc = [];
    let data: any = false;
    for (const university in formFilled) {
      const formData = formFilled[university];
      if (!data) {
        data = formData;
      }
      if (this.fileData[university]) {
        supportDoc.push({
          collegeName: this.fileData[university].universityName,
          session: this.fileData[university].enrollmentYear,
          fileIds: this.fileData[university].fileIds,
          documentTypeId: this.fileData[university].documentFileFormat,
          documentAnalysisId: this.fileAnalysisData[university].id,
          awardLetterDate: this.fileData[university].dateOfAward,
          letterFormat: this.fileData[university].award,
          filledForm: {
            id: formData.id,
            name: formData && formData.formRef ? formData.formRef.name : "",
          },
        });
      }
    }
    const body = {
      filledForm: {
        id: data.id,
        name: data && data.formRef ? data.formRef.name : "",
      },
      organisationRef: org.orgRef,
      supportDocs: supportDoc,
    };
    this.httpser.post(url, body, this.globalvar.isTokenLogin).then((resp) => {
      callback(resp);
    });
  }

  resetFileData() {
    this.fileData = {};
    this.fileAnalysisData = {};
  }

  // fileAnalysisWithdocumentTypeId(
  //   documentTypeIdVal,
  //   universityName,
  //   fileIds,
  //   data,
  //   index,
  //   callback
  // ) {
  //   const url = this.baseUrl + '/ocr/v2/analysis'; // '/ocr/analysis';
  //   let org =  JSON.parse(this.codehelp.getLoggedUserDetail());
  //   let body = {
  //     fileIds: fileIds,
  //     extraText: universityName,
  //     documentTypeId: documentTypeIdVal,
  //     organisationRef: org.orgRef,
  //   };
  //   this.fileData[universityName] = data;

  //   this.http.post(url, body).subscribe(
  //     (resp) => {
  //       console.log(resp);
  //       this.fileAnalysisData[universityName] = resp;
  //       this.fileAnalysisData[universityName].awardType = data.award;
  // fileAnalysisWithdocumentTypeId(
  //   documentTypeIdVal,
  //   universityName,
  //   fileIds,
  //   data,
  //   index,
  //   callback
  // ) {
  //   let org =  JSON.parse(this.codehelp.getLoggedUserDetail());
  //   const url = this.baseUrl + '/ocr/v2/analysis';
  //   // '/ocr/analysis';
  //   let body = {
  //     fileIds: fileIds,
  //     extraText: universityName,
  //     documentTypeId: documentTypeIdVal,
  //     organisationRef:org.orgRef,
  //   };
  //   this.fileData[universityName] = data;

  //   this.http.post(url, body).subscribe(
  //     (resp) => {
  //       console.log(resp);
  //       this.fileAnalysisData[universityName] = resp;
  //       this.fileAnalysisData[universityName].awardType = data.award;

  //     },
  //     (err) => {
  //       console.error(err);
  //       callback();
  //     }
  //   );
  // }

  // uploadFile(file, callback) {
  //   const url = this.baseUrl + '/fileStorage/upload';
  //   const body = {
  //     file: file,
  //   };
  //   var fd = new FormData();
  //   fd.append(
  //     'payload',
  //     JSON.stringify({
  //       bucketName: 'VIRTUE_USER_UPLOADS',
  //       dirPrefix: 'OCR_DOCS',
  //       purpose: 'file upload',
  //     })
  //   );
  //   fd.append('file', file);
  //   this.http.post(url, fd, { headers: new HttpHeaders({ timeout: '2000000' }) })
  //     .subscribe(
  //       (resp) => {
  //         // console.log(resp);
  //         callback(resp);
  //       },
  //       (error) => {
  //         console.log(error);
  //         callback(error);
  //       }
  //     );
  // }

  // unmergePDF(fileId, callback) {
  //   const url = this.baseUrl + '/fileStorage/unmerge/' + fileId;
  //   this.http.get(url).subscribe(
  //     (resp) => {
  //       callback(resp);
  //     },
  //     (err) => {
  //       console.error(err);
  //       callback();
  //     }
  //   );
  // }

  // fileAnalysis(universityName, fileIds, data, index, callback) {
  //   const url = this.baseUrl + '/ocr/analysis';
  //   let body = {
  //     fileIds: fileIds,
  //     extraText: universityName,
  //     organisationRef: this.org,
  //   };
  //   this.fileData[universityName] = data;

  //   this.http.post(url, body).subscribe(
  //     (resp) => {
  //       //console.log(resp);
  //       this.fileAnalysisData[universityName] = resp;
  //       this.fileAnalysisData[universityName].awardType = data.award;
  //       if (this.formReqData) {
  //         this.submitDefaultForm(universityName, resp, index, (response) => {
  //           callback(response);
  //         });
  //       } else {
  //         callback(resp);
  //       }
  //     },
  //     (err) => {
  //       console.error(err);
  //       callback();
  //     }
  //   );
  // }

  /////////==(Start)==========Award letter upload Used this methods==================/////////////

  uploadFile(file, callback) {
    const url = "fileStorage";
    // const body = {
    //   file: file,
    // };
    var fd = new FormData();
    fd.append(
      "payload",
      JSON.stringify({
        bucketName: "VIRTUE_USER_UPLOADS",
        dirPrefix: "OCR_DOCS",
        purpose: "file upload",
      })
    );
    fd.append("file", file);
    this.httpser.upload(url, fd).then(
      (resp) => {
        // console.log(resp);
        callback(resp);
      },
      (error) => {
        console.log(error);
        callback(error);
      }
    );
  }

  uploadWithProgressFile(file, callback) {
    const url = "fileStorage";
    // const body = {
    //   file: file,
    // };
    var fd = new FormData();
    fd.append(
      "payload",
      JSON.stringify({
        bucketName: "VIRTUE_USER_UPLOADS",
        dirPrefix: "OCR_DOCS",
        purpose: "file upload",
      })
    );
    fd.append("file", file);
    this.httpser.upload(url, fd).then(
      (resp) => {
        // console.log(resp);
        callback(resp);
      },
      (error) => {
        console.log(error);
        callback(error);
      }
    );
  }

  unmergePDF(fileId, callback) {
    const url = "fileStorage/unmerge";
    this.httpser.get(url, fileId, this.globalvar.isTokenLogin).then(
      (resp) => {
        callback(resp);
      },
      (err) => {
        console.error(err);
        callback();
      }
    );
  }

  fileAnalysisWithdocumentTypeId(
    documentTypeIdVal,
    universityName,
    fileIds,
    data,
    index,
    callback
  ) {
    const org = JSON.parse(this.codehelp.getLoggedUserDetail());
    const url = "ocr/v2/analysis";
    const body = {
      fileIds: fileIds,
      extraText: universityName,
      documentTypeId: documentTypeIdVal,
      organisationRef: org.orgRef,
    };
    this.fileData[universityName] = data;
    this.httpser.post(url, body, this.globalvar.isTokenLogin).then(
      (resp) => {
        this.fileAnalysisData[universityName] = resp;
        this.fileAnalysisData[universityName].awardType = data.award;
      },
      (err) => {
        callback();
      }
    );
  }
  sendRequestResetPassword(input: any, orgId: string) {
    let body: any = {};
    if ((input.email && input.username) || input.email) {
      body.email = input.email;
      body.orgId = orgId;
    } else {
      body.username = input.username;
    }

    let result = this.httpser.post("virtueAuth/passwordResetInit", body);
    return result;
  }
  checkaccount(input: any) {
    let result = this.httpser.post(
      "virtueAuth/multiAccountWithEmailChecker",
      input
    );
    return result;
  }

  currentPlan(input: any) {
    let result = this.httpser.post("payment/currentPlan", input);
    return result;
  }

  getCollegeProfileIcon(ipedsId: string, cb: Function) {
    let url =
      "https://cdn.virtueanalytics.com/college-logos/" + ipedsId + ".png";

    this.http.get(url).subscribe(
      (resp) => {
        cb(resp);
      },
      (error) => {
        cb(error);
      }
    );
  }

  fileAnalysis(universityName, fileIds, data, index, callback) {
    //  const url = this.baseUrl + '/ocr/analysis';
    const org = JSON.parse(this.codehelp.getLoggedUserDetail());
    const url = "ocr/analysis";
    const body = {
      fileIds: fileIds,
      extraText: universityName,
      organisationRef: org.orgRef,
    };
    this.fileData[universityName] = data;
    this.httpser.post(url, body, this.globalvar.isTokenLogin).then(
      (resp) => {
        //console.log(resp);
        this.fileAnalysisData[universityName] = resp;
        this.fileAnalysisData[universityName].awardType = data.award;
        if (this.formReqData) {
          this.submitDefaultForm(universityName, resp, index, (response) => {
            callback(response);
          });
        } else {
          callback(resp);
        }
      },
      (err) => {
        console.error(err);
        callback();
      }
    );
  }

  fileAnalysisUpdate(universityName, req, data, index, callback) {
    //  const url = this.baseUrl + '/ocr/analysis';
    // let org = JSON.parse(this.codehelp.getLoggedUserDetail());
    // const url = this.baseUrl + '/ocrAnalysisResult/' + req.id;
    this.fileData[universityName] = data;
    this.httpser.put("ocrAnalysisResult", req.id, req).then(
      (resp) => {
        this.fileAnalysisData[universityName] = resp;
        this.fileAnalysisData[universityName].awardType = data.award;
        if (this.formReqData) {
          this.submitDefaultForm(universityName, resp, index, (response) => {
            callback(response);
          });
        } else {
          callback(resp);
        }
      },
      (err) => {
        console.error(err);
        callback();
      }
    );
    // let body = {
    //   fileIds: fileIds,
    //   extraText: universityName,
    //   organisationRef: org.orgRef,
    // };
    // this.fileData[universityName] = data;
    // this.httpser.post(url, body, this.globalvar.isTokenLogin).then(
    //   (resp) => {
    //     //console.log(resp);
    //     this.fileAnalysisData[universityName] = resp;
    //     this.fileAnalysisData[universityName].awardType = data.award;
    //     if (this.formReqData) {
    //       this.submitDefaultForm(universityName, resp, index, (response) => {
    //         callback(response);
    //       });
    //     } else {
    //       callback(resp);
    //     }
    //   },
    //   (err) => {
    //     console.error(err);
    //     callback();
    //   }
    // );
  }

  getAnswersFromAnasysisData(infoData, analysisData) {
    for (let index = 0; index < analysisData.detectedValues.length; index++) {
      const element = analysisData.detectedValues[index];
      const ans1 = {
        fieldNo: element.fieldId,
        value: element.value,
        // 'type': element.,
        label: element.fieldName,
        parentwidgetno: element.mapWith,
      };
      infoData.push(ans1);
      for (let child = 0; child < element.childs.length; child++) {
        const childData = element.childs[child];
        if (childData.fieldId != element.fieldId) {
          let ans2 = {
            fieldNo: childData.fieldId,
            value: childData.value,
            // 'type': element.,
            label: childData.fieldName,
            parentwidgetno: childData.mapWith,
          };
          infoData.push(ans2);
        }
      }
    }
    return infoData;
  }

  getUploadedAwardLetter(id) {
    // let url =this.baseUrl+'/ocr/analysis/'+id;
    const url = "ocr/analysis";
    return this.httpser.get<any>(url, id, this.globalvar.isTokenLogin);
  }

  getfilledByInfo() {
    let answer = [];
    if (!!this.formReqData) {
      for (
        let index = 0;
        index < this.formReqData.filledByInfos.length;
        index++
      ) {
        const element = this.formReqData.filledByInfos[index];
        let _value =
          element.fieldNo != 5
            ? this.data[element.fieldNo]
            : this.data[element.fieldNo].replace(/[^\d]/g, "");
        _value =
          element.fieldNo != 40
            ? this.data[element.fieldNo]
            : this.data[element.fieldNo].replace(/[^\d.]/g, "");
        const ans = {
          fieldNo: element.fieldNo,
          value: _value,
          type: element.display.inputType,
          label: element.display.label,
          parentwidgetno: 0,
        };
        answer.push(ans);
      }
    }
    return answer;
  }
  uploadupdatedFile(file, documentfiletype, universityName, callback) {
    const url = this.globalvar.getHost() + "ocr/upload/analysis";
    // const url = this.baseUrl + "/ocr/upload/analysis";
    const org = JSON.parse(this.codehelp.getLoggedUserDetail());
    const analysisExtraData = {
      //  extraText: universityName,
      organisationRef: org.orgRef,
    };
    var fd = new FormData();
    fd.append(
      "payload",
      JSON.stringify({
        bucketName: "VIRTUE_USER_UPLOADS",
        dirPrefix: "OCR_DOCS",
        purpose: "file upload",
      })
    );
    fd.append(
      "analysisExtraData",
      JSON.stringify({
        extraText: universityName,
        documentTypeId: documentfiletype,
        organisationRef: org.orgRef,
      })
    );
    fd.append("file", file);
    this.http.post(url, fd).subscribe(
      (resp) => {
        // console.log(resp);
        callback(resp);
      },
      (error) => {
        console.log(error);
        callback(error);
      }
    );
  }
  submitDefaultForm(university, fileAnalysisData, index, callback) {
    let url = "formFilled";
    const filledByInfo = this.getfilledByInfo();
    const org = JSON.parse(this.codehelp.getLoggedUserDetail());
    const answers = this.getAnswersFromAnasysisData(
      filledByInfo,
      fileAnalysisData
    );
    const body = {
      formRef: {
        id: this.formReqData.id,
        name: this.formReqData.formName,
      },
      organisationRef: org.orgRef,
      answers: answers,
      submissionState: "INCOMPLETE",
    };
    this.letter = university;
    if (
      (index == 0 && Object.keys(this.FormFilledData).length == 0) ||
      this.FormFilledData[university]
    ) {
      let formId = this.FormFilledData[university]
        ? this.FormFilledData[university].id
        : this.formSubmitId;
      url = "formFilled/";
      // url = 'formFilled/' + formId;
      body["id"] = formId;
      (body["metaData"] = {
        version: this.FormFilledData[university]
          ? this.FormFilledData[university]["metaData"].version
          : this.formVersion,
      }),
        this.httpser
          .put(url, formId, body, this.globalvar.isTokenLogin)
          .then((resp) => {
            this.FormFilledData[university] = resp;
            callback(resp);
          });
    } else {
      this.httpser.post(url, body, this.globalvar.isTokenLogin).then((resp) => {
        this.FormFilledData[university] = resp;
        callback(resp);
      });
    }
  }

  /////////==(End)========Award letter upload Used this methods=====================/////////////

  getCollegeIpedsCost(ipedsId, domicileAndResidency) {
    const url = "collegeIpedsCost/search/calculate";
    const body = {
      pagination: {
        totalSize: 0,
        pageNo: 0,
      },
      ipedsId: ipedsId,
      // year: '2020',
      domicileAndResidency: domicileAndResidency,
    };
    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }

  getMeritScholarShipCombindData(
    ipedsId,
    efc,
    act,
    sat,
    gpa,
    gpaScale,
    state,
    domicileAndResidency,
    preferOutStateGrid
  ) {
    // let url = 'https://tech.virtueanalytics.com/v-failsafe-mvt/combinedAid/calculate';

    const url = "combinedAid/calculate";
    const body = {
      pagination: {
        totalSize: 0,
        pageNo: 0,
      },
      ipedsId: ipedsId,
      efc: efc,
      act: act,
      sat: sat,
      gpa: gpa,
      gpaScale: gpaScale,
      studentEnrollmentStatus: "FULL_TIME",
      studentStateCode: state,
      domicileAndResidency: domicileAndResidency,
      preferOutStateGrid: preferOutStateGrid == "OUT_STATE" ? true : false, //added request on 11 May 2023 by Ravi
      internationalStudent: this.globalvar.isInternatinalStudent,
    };

    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }

  getCollegeWiseProgramData(ipedsId, program) {
    // let url ='https://tech.virtueanalytics.com/ocr-top5-dashboard/collegeROIData/byCourseCategoryCode';
    const url = "collegeROIData/byCourseCategoryCode";
    const body = {
      ipedsId: ipedsId,
      courseCategoryCode: program,
    };
    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }

  submitForm(
    ans: Map<Number, Answer>,
    pageid: number,
    last: boolean,
    formType: string,
    callback: Function
  ) {
    this.answerdata = [];
    const org = JSON.parse(this.codehelp.getLoggedUserDetail());
    ans.forEach((value, _name) => this.answerdata.push(value));
    const path = "formFilled";
    const answers = this.answerdata;
    if (pageid === 0 && this.globalvar.formSubmitId == "") {
      const body = {
        formTypeEnum: formType,
        formRef: {
          id: this.formData?.id,
          name: this.formData?.formName,
        },

        // organisationRef: {
        //   id: this.codehelp.getProviderID(),
        //   name: CONFIG.organizationName,
        // },
        organisationRef: org.orgRef,
        answers: answers,
        submissionState: "INCOMPLETE",
      };
      this.httpser
        .post<FormResponse>(path, body, this.globalvar.isTokenLogin)
        .then((resp: FormResponse) => {
          // this.globalvar.formResponse = resp;
          // this.globalvar.formSubmitId = resp['id'];
          // this.globalvar.formFilledSubmitID = resp['id'];
          callback(resp);
        });
    } else {
      this.globalvar.formResponse.answers = answers;

      this.httpser
        .put<FormResponse>(
          "formFilled",
          this.globalvar.formSubmitId,
          this.globalvar.formResponse,
          this.globalvar.isTokenLogin
        )
        .then(
          (resp: FormResponse) => {
            // this.globalvar.formResponse = resp;
            // this.globalvar.formSubmitId = resp['id'];
            // this.globalvar.formFilledSubmitID = resp['id'];
            callback(resp);
          },
          (error) => {
            if (error.status == "500" || error.status) {
              this.httpser
                .put<FormResponse>(
                  "formFilled",
                  this.globalvar.formSubmitId,
                  this.globalvar.formResponse,
                  this.globalvar.isTokenLogin
                )
                .then((resp: FormResponse) => {
                  //     this.globalvar.formResponse = resp;
                  // this.globalvar.formSubmitId = resp['id'];
                  // this.globalvar.formFilledSubmitID = resp['id'];
                  callback(resp);
                });
            }
          }
        );
    }
  }

  top5UserSubmission(
    formSubmitId: string,
    selectedColleges: any,
    submissionReportLink: string,
    extraData: any,
    callback: Function
  ) {
    this.globalvar.AddWatchList = extraData;
    const org = JSON.parse(this.codehelp.getLoggedUserDetail());
    const path = "top5UserSubmission/submitChoice";
    if (formSubmitId != "") {
      const body = {
        formFilledId: formSubmitId,
        organisationRef: org.orgRef,
        selectedColleges: selectedColleges,
        submissionReportLink: submissionReportLink,
        extraData: extraData,
      };
      this.httpser
        .post<any>(path, body, this.globalvar.isTokenLogin)
        .then((resp: any) => {
          this.submitChoiceResponse = resp;
          this.submitChoiceSubmitedId = resp["id"];
          callback(resp);
        });
    }
  }

  getConfigoptions2() {
    const url = "fieldConfig/search";
    const body = {
      configId: "state_competitors", // 1st dropdown all comp states
      providerId: this.codehelp.getProviderID(),
    };
    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }

  getCollegeByState1(state: string) {
    const body = {
      configId: state,
      providerId: this.codehelp.getProviderID(),
    };
    return this.httpser.post<any>("fieldConfig/search", body);
  }

  getCollegeByState(state: string) {
    const url = "fieldConfig/search";
    const body = {
      configId: state,
      providerId: this.codehelp.getProviderID(),
    };
    return this.httpser.post(url, body, this.globalvar.isTokenLogin);
  }

  searchCollegeName(input: any) {
    const url = "collegeProfile/search/fuzzy";
    return this.httpser.post(url, input, this.globalvar.isTokenLogin);
  }

  ////Callback functions

  getCollegeIpedsCost1(
    ipedsId,
    domicileAndResidency,
    stateCode: string,
    callback: Function
  ) {
    let isReciprocityStateAvailable =
      this.globalvar.ReciprocitySelectedStateList.filter(
        (element) => element.toLowerCase() == stateCode.toLowerCase()
      );

    const url = "collegeCostProfile/search/calculate/combined";
    const body = {
      pagination: {
        totalSize: 0,
        pageNo: 0,
      },
      ipedsId: ipedsId,
      // year: '2020',
      domicileAndResidency: domicileAndResidency,
      reciprocityApplicable:
        isReciprocityStateAvailable.length > 0 ? true : false,
    };
    this.httpser
      .post(url, body, this.globalvar.isTokenLogin)
      .then((res: any) => {
        callback(res);
      });
  }

  getCollegeProfileById1(collegeId: string, callback: Function) {
    this.httpser
      .get<any>(
        "collegeProfile/" + collegeId + "?getExtendedEntity=true",
        "",
        this.globalvar.isTokenLogin
      )
      .then((res: any) => {
        callback(res);
      });
  }

  getMeritScholarShipCombindData1(
    ipedsId,
    efc,
    act,
    sat,
    gpa,
    gpaScale,
    state,
    domicileAndResidency,
    preferOutStateGrid,
    callback: Function
  ) {
    // let url = 'https://tech.virtueanalytics.com/v-failsafe-mvt/combinedAid/calculate';
    let url = "combinedAid/calculate";
    const body = {
      pagination: {
        totalSize: 0,
        pageNo: 0,
      },
      ipedsId: ipedsId,
      efc: efc,
      act: act,
      sat: sat,
      gpa: gpa,
      gpaScale: gpaScale,
      studentEnrollmentStatus: "FULL_TIME",
      studentStateCode: state,
      domicileAndResidency: domicileAndResidency,
      preferOutStateGrid: preferOutStateGrid == "OUT_STATE" ? true : false, //added request on 11 May 2023 by Ravi
      internationalStudent: this.globalvar.isInternatinalStudent,
      // preferOutStateGrid: true,  //added request on 11 May 2023 by Ravi
    };
    this.httpser
      .post(url, body, this.globalvar.isTokenLogin)
      .then((res: any) => {
        callback(res);
      });
  }

  getCollegeWiseProgramData1(ipedsId, program, callback: Function) {
    // let url ='https://tech.virtueanalytics.com/v-vaibhav-dev/collegeROIData/byCourseCategoryCode';
    const url = "collegeROIData/byCourseCategoryCode";
    const body = {
      ipedsId: ipedsId,
      courseCategoryCode: program,
    };
    // this.httpser.post(url, body)
    this.httpser
      .post(url, body, this.globalvar.isTokenLogin)
      .then((res: any) => {
        callback(res);
      });
  }

  getCollegeIpedsWiseAllProgramData(ipedsId, program) {
    // let url ='https://tech.virtueanalytics.com/v-vaibhav-dev/collegeROIData/byCourseCategoryCode';
    const url = "collegeROIData/";
    // const body = {
    //   ipedsId: ipedsId,
    //   courseCategoryCode: program,
    // };
    // this.httpser.post(url, body)

    return this.httpser.get(url + ipedsId, "", this.globalvar.isTokenLogin);

    // this.httpser.get(url+ipedsId,'', this.globalvar.isTokenLogin)
    //   .then((res: any) => {
    //     callback(res);
    //   });
  }
  // extendday(input:any){
  //   let url='extendTop5DemoAccess?email='+input.username+'&password='+input.password+'&numOfDays='+ input.extendDay;
  //   return this.httpser.get<any>('virtueAuth/'+url, '');
  // }

  extendday(input: any) {
    const body = {
      email: input.username,
      password: input.password,
      numOfDays: input.extendDay,
    };
    return this.httpser.post<any>(
      "virtueAuth/extendTop5DemoAccessEnhanced",
      body
    );
  }

  getOrganizationById(id: string) {
    return this.httpser.get<any>(
      "organisation/" + id,
      "",
      this.globalvar.isTokenLogin
    );
  }
  checkOldPassword(input: any) {
    return this.httpser.post<LoginInfo>("virtueAuth/checkCredentials", input);
  }
  resetpassword(input: any) {
    // let body = {
    //   Code:input.code,
    //   Password:input.password
    // }
    return this.httpser.post<any>("virtueAuth/admin/passwordReset", input);
  }
}
